import api from "@/api";
export default class Masterlist {
  constructor(_default) {
    if (_default !== undefined) {
      this._default = _default;
      for (let prop in _default) {
        this[prop] = _default[prop];
      }
    }
  }

  static async fetch(m_id) {
    const res = await api.get(`/api/v1/repair/masterlist/`, { id: m_id });
    if (res) return res.data.data[0];
    return null;
  }

  static async list(params) {
    const res = await api.get(`/api/v1/repair/masterlist/`, params);
    if (res) return res.data;
    return null;
  }

  static async store(payload) {
    const res = await api.post(`/api/v1/repair/create/masterlist/`, payload);
    if (res) return res.data.data;
    return null;
  }

  static async update(payload) {
    const res = await api.put(
      `/api/v1/repair/update/masterlist/${payload.id}/`,
      payload
    );
    if (res) return res.data.data;
    return null;
  }

  static async searchUld(params) {
    const res = await api.get(`/api/v1/repair/search_uld/masterlist/`, params);
    if (res) return res.data.data;
    return [];
  }

  static async getULDList(params) {
    const res = await api.get(
      `/api/v1/repair/masterlist/ulds/?id=${params.masterlist_id}`,
      params
    );
    if (res) return res.data;
    return {};
  }

  // static descriptions() {
  //   return [
  //     { value: "A", text: "AKE/LD3-Alu Container" },
  //     { value: "B", text: "AKE/LD3-LW Container" },
  //     { value: "C", text: "AKH/LD45-Alu Container" },
  //     { value: "D", text: "AKN/LD3-Alu Container" },
  //     { value: "E", text: "ALF/LD6-Alu Container" },
  //     { value: "F", text: "ALF/LD6-LW Container" },
  //     { value: "G", text: "AMF/LD36-Alu Container" },
  //     { value: "H", text: "AMP/LD39-Alu Container" },
  //     { value: "I", text: "AVA/LD3-Alu Container" },
  //     { value: "J", text: "FSK/LD3-Alu container" },
  //     { value: "K", text: "Horse Stall-ECS" },
  //     { value: "L", text: 'PAG Pallet 88"x125"' },
  //     { value: "M", text: 'PAJ Pallet 88"x125"' },
  //     { value: "N", text: 'PGE Pallet 96"x20ft.' },
  //     { value: "O", text: 'PGF Pallet 96"x20ft.' },
  //     { value: "P", text: 'PKC Pallet 55.4"X56.4"' },
  //     { value: "Q", text: 'PLA Pallet 60.4"x125"' },
  //     { value: "R", text: 'PMC Pallet 96"x125"' },
  //     { value: "S", text: 'PRA Pallet 96"x196" 16 ft.' },
  //     { value: "T", text: 'PYB Pallet 55"x96"' },
  //     { value: "U", text: 'PZA Pallet 96"x16ft.' },
  //     { value: "V", text: "RKE/LD3-Alu Container" },
  //     { value: "W", text: "XKF/LD3-Alu Container" },
  //     { value: "X", text: "XKN/LD3-Alu Container" },
  //     { value: "Y", text: "IGR042-Full Size Waste Cart" },
  //     { value: "Z", text: "IGR043-Half Size Waste Cart" },
  //     { value: "AA", text: "IGR711-Atlas Trolley FS Hybrite" },
  //     { value: "AB", text: "IGR712-Atlas Trolley HS Hybrite" },
  //     { value: "AC", text: "IGR713-Waste Trolley FS Hybrite" },
  //     { value: "AD", text: "IGR735-Full Size Meal Cart" },
  //     { value: "AE", text: "IGR736-Half Size Meal Cart" }
  //   ];
  // }

  static descriptions() {
    return [
      { value: "Horse Stall", text: "Horse Stall" },
      { value: "AKE/LD3-Alu Container", text: "AKE/LD3-Alu Container" },
      { value: "AKE/LD3-LW Container", text: "AKE/LD3-LW Container" },
      { value: "ALF/LD6-Alu Container", text: "ALF/LD6-Alu Container" },
      { value: "ALF/LD6-LW Container", text: "ALF/LD6-LW Container" },
      { value: "AMP/LD39-Alu Container", text: "AMP/LD39-Alu Container" },
      { value: "AVA/LD3-Alu Container", text: "AVA/LD3-Alu Container" },
      { value: "DQF/LD8-LW Container", text: "DQF/LD8-LW Container" },
      { value: "Horse Stall-ECS", text: "Horse Stall-ECS" },
      { value: 'PAG Pallet 88x125"', text: 'PAG Pallet 88x125"' },
      { value: 'PAJ Pallet 88x125"', text: 'PAJ Pallet 88x125"' },
      { value: 'PGE Pallet 96x20ft."', text: 'PGE Pallet 96x20ft."' },
      { value: 'PKC Pallet 55.4X56.4"', text: 'PKC Pallet 55.4X56.4"' },
      { value: 'PLA Pallet 60.4x125"', text: 'PLA Pallet 60.4x125"' },
      { value: 'PMC Pallet 96x125"', text: 'PMC Pallet 96x125"' },
      { value: 'PRA Pallet 96x196" 16 ft.', text: 'PRA Pallet 96x196" 16 ft.' },
      { value: 'PYB Pallet 55x96"', text: 'PYB Pallet 55x96"' },
      { value: "XKN/LD3-Alu Container", text: "XKN/LD3-Alu Container" },
      { value: 'PGA Pallet 96x20ft."', text: 'PGA Pallet 96x20ft."' },
      { value: 'PGF Pallet 96x20ft."', text: 'PGF Pallet 96x20ft."' },
      { value: "DQF/LD8-Alu Container", text: "DQF/LD8-Alu Container" },
      { value: 'PZA Pallet 96x16ft."', text: 'PZA Pallet 96x16ft."' },
      { value: 'FQA Pallet 60.4x96"', text: 'FQA Pallet 60.4x96"' },
      { value: "LAY/MD-Container", text: "LAY/MD-Container" },
      { value: 'PLB Pallet 60.4x125"', text: 'PLB Pallet 60.4x125"' },
      { value: "RKN/LD3-e1 Container", text: "RKN/LD3-e1 Container" },
      { value: "DPE/LD2-Alu Container", text: "DPE/LD2-Alu Container" },
      { value: "AVA/LD3-LW Container", text: "AVA/LD3-LW Container" },
      { value: 'PEB Pallet 53x88"', text: 'PEB Pallet 53x88"' },
      { value: 'FLA Pallet 60.4x125"', text: 'FLA Pallet 60.4x125"' },
      { value: "AKH/LD45-Alu Container", text: "AKH/LD45-Alu Container" },
      { value: "IGR823-Full Size Meal Cart", text: "IGR823-Full Size Meal Cart" },
      { value: "IGR014-Atlas Container", text: "IGR014-Atlas Container" },
      { value: "IGR059-G Extended Oven Insert", text: "IGR059-G Extended Oven Insert" },
      { value: "IGR805-Full Size Waste Cart", text: "IGR805-Full Size Waste Cart" },
      { value: "IGR806-Half Size Waste Cart", text: "IGR806-Half Size Waste Cart" },
      { value: "IGR824-Half Size Meal Cart", text: "IGR824-Half Size Meal Cart" },
      { value: "IGR813- Atlas Hybrite FW Cart", text: "IGR813- Atlas Hybrite FW Cart" },
      { value: "IGR814-Atlas Hybrite HW Cart", text: "IGR814-Atlas Hybrite HW Cart" },
      { value: "IGR811-Atlas Hybrite FM Cart", text: "IGR811-Atlas Hybrite FM Cart" },
      { value: "IGR812-Atlas Hybrite HM Cart", text: "IGR812-Atlas Hybrite HM Cart" },
      { value: "IGR825-Full Size Meal Cart", text: "IGR825-Full Size Meal Cart" }
    ];

  }
}
